import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const FileVisibilityLearnMoreLink = () => /*#__PURE__*/_jsx("div", {
  className: "m-top-3",
  children: /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: "https://knowledge.hubspot.com/cos-general/copy-and-update-the-url-of-files-uploaded-to-the-file-manager",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'FileManagerCore.fileVisibility.learnMore'
    })
  })
});
export default FileVisibilityLearnMoreLink;